import { defineStore } from "pinia";
import { ref } from "vue";

const oldRevealActions = window.revealActions;
window.revealActions = function () {
    if (oldRevealActions != null) {
        oldRevealActions();
    }
    const rev = useRevealActions();

    rev.revealActions = true;

    console.log(rev);
};

export const useRevealActions = defineStore("revealActions", () => {
    const revealActions = ref<boolean>(false);

    return {
        revealActions,
    };
});
